export default "__VITE_ASSET__DmjRjqu8__"